import { FiDatabase, FiDollarSign, FiDroplet, FiFileText, FiUser } from 'react-icons/fi';

export const INVESTMENT_SLIDER = [
  {
    title: 'Yearly Invoice',
    price: 985000,
    icon: <FiDollarSign className='w-h-24' />,
  },
  {
    title: 'Yearly Investment',
    price: 126000,
    icon: <FiDatabase className='w-h-24' />,
  },
  {
    title: 'This Month User',
    price: 84000,
    icon: <FiUser className='w-h-24' />,
  },
  {
    title: 'Launched Product',
    price: 324000,
    icon: <FiFileText className='w-h-24' />,
  },
  {
    title: 'Yearly Visitors',
    price: 2556000,
    icon: <FiDroplet className='w-h-24' />,
  },
  {
    title: 'Yearly Investment',
    price: 126000,
    icon: <FiDatabase className='w-h-24' />,
  },
];
